import DialogButton from './DialogButton'
export default DialogButton



// WEBPACK FOOTER //
// ./src/components/DialogButton/index.js